export enum Onboarding {
  MobilePay = 'MOBILEPAY',
  PayPal = 'PAYPAL',
}
